<div class="vertical-container contents" style="min-height: 10rem">
    <div class="horizontal-container vertical-align bottom-buffer">
        <h4
            class="inline-heading right-buffer"
            [ngClass]="{ disabled: isReadOnly }"
        >
            Approval {{ approvalNumber }}
        </h4>
        <mission-approval-status
            [status]="approval.approval.status"
        ></mission-approval-status>
    </div>
    <span class="top-buffer bottom-buffer"
        ><strong>Ruleset&nbsp;</strong>
        {{
            approval.authorityType?.ruleset?.name != null
                ? approval.authorityType?.ruleset?.name
                : 'None'
        }}
    </span>
    <span
        ><strong>Authority&nbsp;</strong>
        {{
            (getSimplifiedAuthorityFromApproval(approval, organisation)
                | formatAuthority) || 'None'
        }}
    </span>
</div>

<!-- The requester's read only view of the approver's outcome. -->
<div class="row" *ngIf="!hasApprove && isApproved">
    <div class="col-xs-12 col-md-5">
        <h4>Message from Approver</h4>
        <p class="pre-line" *ngIf="requestersApproval.messageFromApprover">
            {{ requestersApproval.messageFromApprover }}
        </p>
        <p *ngIf="!requestersApproval.messageFromApprover">
            There is no message from the approver
        </p>
    </div>
    <div class="col-xs-12 col-md-7">
        <h4>Approved Max Height</h4>
        <p *ngIf="requestersApproval.maximumHeight != null">
            {{ requestersApproval.maximumHeight }} ft AGL
        </p>
        <p *ngIf="requestersApproval.maximumHeight == null">
            No maximum height has been specified
        </p>
        <h4 class="top-buffer">Conditions</h4>
        <ol *ngIf="requestersConditions.length > 0">
            <li *ngFor="let condition of requestersConditions">
                {{ condition }}
            </li>
        </ol>
        <p *ngIf="requestersConditions.length === 0">
            No conditions have been applied
        </p>
    </div>
</div>

<ng-container *ngIf="approval$ | async as fullApproval">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-xs-12 col-md-5">
                <h4>Message to Remote Pilot</h4>
                <enhanced-help
                    screenName="mission-approval-v2-dialogue"
                    componentName="messageToRemotePilot"
                    [compact]="true"
                >
                </enhanced-help>
                <textarea
                    class="form-control textarea-lock-width"
                    style="width: 100%; height: 200px"
                    formControlName="messageFromApprover"
                    placeholder="Your mission..."
                    [disableControl]="isReadOnly"
                >
                </textarea>
            </div>
            <div class="col-md-7">
                <div class="form-group top-buffer">
                    <enhanced-help
                        screenName="mission-approval-v2-dialogue"
                        componentName="maxHeight"
                        [compact]="true"
                    >
                    </enhanced-help>
                    <label>Approved Max Height</label>
                    <div class="input-group">
                        <input
                            type="number"
                            formControlName="maximumHeight"
                            placeholder="The maximum flight height above ground level that is approved of the mission"
                            min="0"
                            step="1"
                            class="form-control"
                            [disableControl]="isReadOnly"
                        />
                        <span class="input-group-addon"> ft AGL </span>
                    </div>
                </div>
                <table class="table" #approvalConditionsTable>
                    <thead>
                        <th *ngIf="!isReadOnly" style="width: 50px">
                            <button
                                class="btn-circle btn-link"
                                (click)="addCondition()"
                            >
                                <span class="fa fa-plus"></span>
                            </button>
                        </th>
                        <th>
                            <h4 class="align-heading">
                                <span>Conditions</span>
                                <button
                                    class="btn btn-xs btn-default spacing pull-right"
                                    (click)="addConditionsFromLibrary()"
                                    *ngIf="
                                        !isReadOnly &&
                                        canUseApprovalConditionsLibrary
                                    "
                                >
                                    Add Condition From Library
                                </button>
                            </h4>
                            <enhanced-help
                                screenName="mission-approval-v2-dialogue"
                                componentName="approvalConditions"
                                [compact]="true"
                            >
                            </enhanced-help>
                        </th>
                        <th style="width: 50px"></th>
                    </thead>
                    <tbody
                        *ngIf="!isReadOnly"
                        formArrayName="conditions"
                        cdkDropList
                        (cdkDropListDropped)="
                            drop($event, formConditions.controls)
                        "
                    >
                        <tr
                            *ngFor="
                                let condition of formConditions.controls;
                                let i = index
                            "
                            cdkDrag
                        >
                            <td *ngIf="!isReadOnly" class="text-right">
                                <span
                                    class="fas fa-grip-vertical row-hover grab-handle"
                                    cdkDragHandle
                                ></span>
                            </td>
                            <td>
                                <textarea
                                    [formControlName]="i"
                                    class="form-control textarea-lock-width"
                                    rows="2"
                                ></textarea>
                            </td>
                            <td>
                                <button
                                    class="btn btn-tertiary btn-delete"
                                    (click)="deleteCondition(i)"
                                >
                                    <span class="fal fa-trash-alt"></span>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td [attr.colspan]="isReadOnly ? 2 : 3">
                                <div
                                    *ngIf="
                                        !isReadOnly &&
                                        formConditions.length === 0
                                    "
                                    class="alert alert-info"
                                >
                                    There are no conditional currently applied.
                                    Add one using the + or the conditions
                                    library
                                </div>
                                <p
                                    *ngIf="
                                        isReadOnly &&
                                        (fullApproval.conditions == null ||
                                            fullApproval.conditions.length ===
                                                0)
                                    "
                                    class="align-heading"
                                >
                                    No conditions were applied
                                </p>
                            </td>
                        </tr>
                    </tfoot>
                </table>

                <ol *ngIf="isReadOnly">
                    <li *ngFor="let condition of fullApproval.conditions">
                        {{ condition }}
                    </li>
                </ol>
            </div>
        </div>

        <div *ngIf="!readonly" class="row top-buffer">
            <div class="col-xs-12">
                <h4>Internal Approval Notes</h4>
                <textarea
                    class="form-control textarea-lock-width"
                    formControlName="approversNotes"
                    [disableControl]="isReadOnly"
                    rows="5"
                >
                </textarea>
            </div>
        </div>

        <div class="row top-buffer">
            <div class="col-sm-5 col-md-5 col-xl-4">
                <div class="horizontal-container vertical-align">
                    <h4 class="right-buffer">Approval Checklist</h4>
                    <field-validation-indicator [valid]="isMissionApprovable">
                    </field-validation-indicator>
                </div>
                <enhanced-help
                    screenName="mission-approval-v2-dialogue"
                    componentName="approvalChecklist"
                    [compact]="true"
                >
                </enhanced-help>
                @if (fullApproval.mappedApproverChecks != null) {
                <div
                    *ngIf="
                        fullApproval.mappedApproverChecks['pre-submit']
                            .length === 0
                    "
                    class="alert alert-info"
                >
                    There are no approval checks on this authority
                </div>
                <table>
                    <tbody>
                        <ng-container
                            *ngIf="
                                fullApproval.mappedApproverChecks['pre-submit']
                                    .length > 0
                            "
                        >
                            <tr
                                *ngFor="
                                    let check of fullApproval
                                        .mappedApproverChecks['pre-submit']
                                "
                            >
                                <td>
                                    <div class="checkbox">
                                        <label>
                                            <input
                                                type="checkbox"
                                                [(checklist)]="
                                                    fullApproval.completedChecks
                                                "
                                                [checklistValue]="check.id"
                                                (checklistChange)="
                                                    markApprovalChecklistChanged()
                                                "
                                                [disabled]="isReadOnly"
                                            />
                                            <span class="cr">
                                                <i
                                                    class="cr-icon glyphicon glyphicon-ok"
                                                ></i>
                                            </span>
                                            {{ check.check }}
                                        </label>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
                }
            </div>
        </div>
    </form>
</ng-container>

<ng-container *ngIf="approval$ | async">
    <div class="row top-buffer">
        <div class="col-xs-12">
            <div class="pull-right">
                <!-- Save -->
                <button
                    class="btn btn-default"
                    type="button"
                    *ngIf="!isReadOnly"
                    (click)="save()"
                    [disabled]="working || isEditingAttachments"
                >
                    Save
                </button>

                <!-- Lock / Unlock Request -->
                <button
                    class="btn btn-primary left-buffer"
                    type="button"
                    *ngIf="status?.isBeingReviewed && !readonly"
                    (click)="stopProgress()"
                    [disabled]="working"
                >
                    Unlock Request
                </button>

                <button
                    class="btn btn-primary left-buffer"
                    type="button"
                    *ngIf="status?.isPending && !readonly"
                    (click)="startProgress()"
                    [disabled]="working"
                >
                    Lock Request
                </button>

                <button
                    class="btn btn-primary left-buffer"
                    type="button"
                    *ngIf="!isReadOnly"
                    (click)="reject()"
                    [disabled]="working || isEditingAttachments"
                >
                    Reject
                </button>

                <button
                    class="btn btn-primary left-buffer"
                    type="button"
                    (click)="approve()"
                    *ngIf="!isReadOnly && !isMissionApprovalRevokeable"
                    [disabled]="
                        !isMissionApprovable ||
                        working ||
                        isEditingAttachments ||
                        hasBlockingLotams ||
                        !allLotamsAcknowledgedByApprover
                    "
                    [tooltip]="
                        hasBlockingLotams
                            ? 'There is a LOTAM blocking this mission'
                            : !allLotamsAcknowledgedByApprover
                            ? 'All LOTAMs need to be acknowledged before approving'
                            : null
                    "
                >
                    Approve
                </button>

                <button
                    class="btn btn-primary left-buffer"
                    type="button"
                    (click)="revoke()"
                    *ngIf="isMissionApprovalRevokeable"
                    [disabled]="working || isEditingAttachments"
                >
                    Revoke Approval
                </button>
            </div>
        </div>
    </div>
</ng-container>
